module.exports = __webpack_public_path__ + "img/defocused-image-of-illuminated-christmas-lights-255377.93fc6905.jpg";